import { render, staticRenderFns } from "./BannerPictureThumbnailCreate.vue?vue&type=template&id=264d4aae&"
import script from "./BannerPictureThumbnailCreate.vue?vue&type=script&lang=js&"
export * from "./BannerPictureThumbnailCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports